import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'
import { EditProcessForm } from './edit-process-form/edit-process-form'
import { ReturnProcess } from '@/domain/returns'
import { sumCompensation } from '@/domain/refund'

const { DialogTitle, DialogDescription, DialogCloseButton, DialogHeader } = Base

interface EditProcessProps {
  process: ReturnProcess
  onClose: () => void
}

export const EditProcess = ({ process, onClose }: EditProcessProps) => {
  const { t } = useTranslation()

  const compensation = process?.compensation ?? {}

  const totalAmount = Number(
    sumCompensation(compensation, 'adjustedCommitment').amount
  )

  const formattedOriginalRefundAmount = Math.max(totalAmount, 0).toFixed(2)

  const currency = process.currencyCode

  return (
    <div className="w-[30rem]">
      <DialogCloseButton />
      <div className="space-y-3">
        <DialogHeader>
          <DialogTitle>{t('process_details_page.edit_refund')}</DialogTitle>
          <DialogDescription>
            {t('process_details_page.edit_refund_description')}
          </DialogDescription>
        </DialogHeader>
        <EditProcessForm
          onClose={onClose}
          refundAmount={{
            amount: formattedOriginalRefundAmount,
            currency
          }}
          process={process}
        />
      </div>
    </div>
  )
}
